import React, { useEffect, useState, useMemo } from "react";
import {
  Col,
  Row,
  Card,
  Dropdown,
  Table,
  Container,
  Spinner,
} from "react-bootstrap";
import "./UserLandingPage.css";
import UserLandingPageCard from "./UserLandingPageCard";
import firstTitleIcon from "../../../assets/images/user-landing-page/first-title-icon.svg";
import secondTitleIcon from "../../../assets/images/user-landing-page/second-title-icon.svg";
import thirdTitleIcon from "../../../assets/images/user-landing-page/third-title-icon.svg";
import barIcon from "../../../assets/images/barIcon.svg";
import { useCookies } from "react-cookie";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import {
  fetchCordinatorMatric,
  fetchIndividualTrainingProgram,
  fetchTrainingProgramProgress,
} from "ServerAPI/serverAPI";
import _ from "lodash";
import SharedTable from "components/table/SharedTable";
import { useNavigate } from "react-router-dom";
import TrainingProgramProgress from "./TrainingProgramProgress";
import { CircularProgress } from "@mui/material";

const OrganisationCordinator = ({ metricsDetails }) => {
  const [cookies] = useCookies();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataRows, setDataRows] = useState([]);
  const [fixedDataRows, setFixedDataRows] = useState([]);
  const [totalCourses, setTotalCourses] = useState(0);
  const [totalPrograms, setTotalPrograms] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [trainingProgramProgress, setTrainingProgramProgress] = useState([]);
  const [fixedTrainingProgramProgress, setFixedTrainingProgramProgress] =
    useState([]);
  const [totalCordinators, setTotalCordinators] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [activeProgressCard, setActiveProgressCard] = useState("");
  const [loadTableOnly, setLoadTableOnly] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [activeTrainingProgramCard, setActiveTrainingProgramCard] =
    useState(null);
  const [questions,setQuestions] = useState([]);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        cell: ({ row }) => (
          <div style={{ fontWeight: 700 }}>{row.original.name}</div>
        ),
      },
      { accessorKey: "userGroupsCount", header: "Training Program Count" },
      { accessorKey: "usersCount", header: "Users Count" },
    ],
    []
  );

  const deBounedhandleSearch = (e) => {
    if (e.target.value.length === 0) {
      setDataRows(fixedDataRows);
      return;
    }
    const allDataRows = [...fixedDataRows];
    const result = allDataRows.filter((row) => {
      return row.name.toLowerCase().includes(e.target.value.toLowerCase());
    });
    setDataRows(result);
  };
  const handleSearch = _.debounce(deBounedhandleSearch, 500);
  const structureTheRows = (rows = []) => {
    const desiredStructure = rows.map((row) => {
      return {
        ...row,
        courses: row.courses
          .map((course) => {
            return course.courseTitle;
          })
          .join(", "),
        courseDepartment: row.department,
        completionPercentage: row.completionPercentage?.toFixed(2),
      };
    });
    // setDataRows(desiredStructure);
    setFixedDataRows(desiredStructure);
  };

  const onClickHander = (path) => {
    if (path === "/about-organization") {
      navigate(path, {
        state: {
          showProgramCordinatorTab: true,
        },
      });
    } else {
      navigate(path);
    }
  };

  const getCordinatorMatric = async () => {
    const response = await fetchCordinatorMatric(cookies.userId);
    if (response.status === 200) {
      setTotalCourses(response.data?.[0]?.totalCourses);
      setTotalPrograms(response.data?.[0]?.totalPrograms);
      setTotalUsers(response.data?.[0]?.totalUsers);
      setTotalCordinators(response.data?.[0]?.totalCoordinators);
    }
  };

  const getTrainingProgramProgress = async (
    groupId = "",
    fetchTableDataOnly = false
  ) => {
    if (groupId || fetchTableDataOnly) {
      setLoadingTable(true);
    } else {
      setShowLoader(true);
    }

    const response = await fetchTrainingProgramProgress(cookies.userId);
    if (response.status === 200) {
      setTrainingProgramProgress(response.data);
      setFixedTrainingProgramProgress(response.data);
      if (selectedGroup === null) {
        setSelectedGroup(response.data?.[0]);
      }
    }

    setShowLoader(false);
    setLoadingTable(false);
  };
  const fetchOverAllDetails = async (groupId) => {
    setLoadTableOnly(true);
    const result = await fetchIndividualTrainingProgram(
      cookies.userId,
      groupId
    );
    if (result.status === 200) {
      const sendRows=result.data.userData
      setQuestions(result.data.questions.questions);
      const formattedRows = sendRows.map((row, index) => {
        return {
          ...row,
          progress: row?.overallProgress.toFixed(2),
          id: index + 1,
        };
      });
      

      setDataRows(formattedRows);
      setFixedDataRows(formattedRows);
    }
    setLoadTableOnly(false);
  };

  useEffect(() => {
    getCordinatorMatric();
    getTrainingProgramProgress();
  }, []);
  const handleClick = (userGroupId, group) => {
    setActiveTrainingProgramCard(1);
    setSelectedGroup(group);
    fetchOverAllDetails(userGroupId);
  };

  const fetchIndividualCourseDetails = async (courseId) => {
    setLoadTableOnly(true);
    const result = await fetchIndividualTrainingProgram(
      cookies.userId,
      selectedGroup?.userGroupId,
      courseId
    );
    if (result.status === 200) {
      const sendRows=result.data.userData
      // console.log(result.data.questions.questions);
      setQuestions(result.data.questions.questions);

      const formattedRows = sendRows.map((row, index) => {
        return {
          ...row,
          progress: row?.courseProgress?.toFixed(2),
          id: index + 1,
          attempts: row?.quizAttemptCount,
          score: row?.quizScore.toFixed(2),
        };
      });

      setDataRows(formattedRows);
      setFixedDataRows(formattedRows);
      setShowTable(true);
    }
    setLoadTableOnly(false);
  };

  const handleCourseChange = (e) => {
    if (e.target.value) {
      fetchIndividualCourseDetails(e.target.value);
    }
  };
  return (
    <>
      {showLoader ? (
        <>
          <div className="d-flex justify-content-center mt-5">
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          <Card>
            <Card.Body>
              <Row className="">
                <Col xl={3} lg={6} md={12} sm={12}>
                  <UserLandingPageCard
                    title="COURSES"
                    titleIcon={firstTitleIcon}
                    barIcon={barIcon}
                    value={totalCourses}
                  />
                </Col>

                <Col xl={3} lg={6} md={12} sm={12}>
                  <UserLandingPageCard
                    title="ACTIVE TRAINING PROGRAMS"
                    titleIcon={secondTitleIcon}
                    barIcon={barIcon}
                    value={totalPrograms}
                  />
                </Col>

                <Col xl={3} lg={6} md={12} sm={12}>
                  <UserLandingPageCard
                    title="PROGRAM COORDINATORS"
                    titleIcon={thirdTitleIcon}
                    barIcon={barIcon}
                    value={totalCordinators}
                  />
                </Col>
                <Col xl={3} lg={6} md={12} sm={12}>
                  <UserLandingPageCard
                    title="PARTICIPANTS"
                    titleIcon={thirdTitleIcon}
                    barIcon={barIcon}
                    value={totalUsers}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <div className="mt-5">
            <TrainingProgramProgress
              data={trainingProgramProgress}
              questions={questions}
              setData={setTrainingProgramProgress}
              fixedData={fixedTrainingProgramProgress}
              rows={dataRows}
              handleSearch={handleSearch}
              handleClick={handleClick}
              loadingTable={loadingTable}
              selectedGroup={selectedGroup}
              handleCourseChange={handleCourseChange}
              loadTableOnly={loadTableOnly}
              showTable={showTable}
              setShowTable={setShowTable}
              fetchOverAllData={getTrainingProgramProgress}
              activeTrainingProgramCard={activeTrainingProgramCard}
              setActiveTrainingProgramCard={setActiveTrainingProgramCard}
            />
          </div>
        </>
      )}
    </>
  );
};

export default OrganisationCordinator;
